import { render, staticRenderFns } from "./WafIssueBody.vue?vue&type=template&id=ff1a6804&scoped=true"
import script from "./WafIssueBody.vue?vue&type=script&lang=js"
export * from "./WafIssueBody.vue?vue&type=script&lang=js"
import style0 from "./WafIssueBody.vue?vue&type=style&index=0&id=ff1a6804&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff1a6804",
  null
  
)

export default component.exports